import styled from 'styled-components';

import MicrobitFront from '../../media/microbit-front.png';
import MicrobitBack from '../../media/microbit-back.png';

const StyledMicrobit = styled.div`
	position: relative;
	perspective: 1000;
`;

export default StyledMicrobit;

export const Device = styled.div.attrs({
	style: ({accelerometer}) => ({
		transform: `rotateX(${accelerometer.roll}deg) rotateY(${accelerometer.pitch}deg)`,
	}),
})`
	position: relative;
	transform-origin: 50% 50%;
	transform-style: preserve-3d;
	height: 364px;
	width: 431px;
	max-width: calc(100% - 40px);
	margin: 40px auto;
`;

const Side = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	backface-visibility: hidden;
	background-size: contain;
	background-repeat: no-repeat;
`;

export const Front = Side.extend`
	background-image: url(${MicrobitFront});
	z-index: 10;
`;

export const Back = Side.extend`
	background-image: url(${MicrobitBack});
	transform: rotateY(180deg);
`;



// WEBPACK FOOTER //
// ./src/components/Microbit/Microbit.styles.js